module.exports = __webpack_public_path__ + "img/Alpiq_120X35.74c3a3b7.png";